module.exports = __webpack_public_path__ + "img/bg.a09a89de.png";